"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
/**
 * 重要机构持股公用配置
 */
var moment_1 = __importDefault(require("moment"));
var fieldtools_1 = __importDefault(require("../../src/modules/commonutil/fieldtools"));
var pagedata = window["pagedata"];
var pageopt = {
    urlkeyvalues: {
        pagenumber: "pageNumber",
        pagesize: "pageSize",
        sortname: "sortColumns",
        sortorder: "sortTypes"
    },
    dataconfig: {
        gaikuang: { type: "RPT_NATIONAL_MARKET_STATISTICS", showcount: 5, sortname: "REPORT_DATE", sortorder: "-1", filter: "(TRADE_MARKET=\"all\")(REPORT_DATE>'" + moment_1["default"]().add({ years: -2 }).format("YYYY-MM-DD") + "')" },
        mx: { type: "RPT_NATIONAL_STATISTICS", showcount: 5, sortname: "SHARES_RATIO_CHANGE", sortorder: "-1", filter: "(REPORT_DATE='" + (pagedata === null || pagedata === void 0 ? void 0 : pagedata.datedef.REPORT_DATE) + "')" },
        tj: { type: "RPT_NATIONAL_ORGHOLD_STATISTICS", showcount: 5, sortname: "MARKET_CAP_CHG", sortorder: "-1", filter: "(REPORT_DATE='" + (pagedata === null || pagedata === void 0 ? void 0 : pagedata.datedef.REPORT_DATE) + "')" },
        hy: { type: "RPT_NATIONAL_INDUSTRY_STATISTICS", showcount: 5, sortname: "AVG_SHARES_RATIO", sortorder: "-1", filter: "(REPORT_DATE='" + (pagedata === null || pagedata === void 0 ? void 0 : pagedata.datedef.REPORT_DATE) + "')" }
    },
    columns: {
        "xg_stock": {
            formatter: function (value, item, i, field) {
                return "<a class=\"red\" href=\"/gjdcg/stock/" + item.SECURITY_CODE + ".html\">\u8BE6\u7EC6</a>&nbsp;\n                <a href=\"/stockdata/" + item.SECURITY_CODE + ".html\">\u6570\u636E</a>&nbsp;\n                <a href=\"/notices/stock/" + item.SECURITY_CODE + ".html\">\u516C\u544A</a>";
            }
        },
        "xg_gg": {
            formatter: function (value, item, i, field) {
                return "<a class=\"red\" href=\"/gjdcg/stock/" + item.SECURITY_CODE + ".html\">\u8BE6\u7EC6</a>";
            }
        },
        "xg_ggmx": {
            formatter: function (value, item, i, field) {
                return "<a class=\"red\" href=\"/gjdcg/stock/" + item.SECURITY_CODE + ".html\">\u4E2A\u80A1\u660E\u7EC6</a>";
            }
        },
        "xg_jg": {
            formatter: function (value, item, i, field) {
                return "<a class=\"red\" href=\"/gjdcg/jg/" + item.HOLDER_CODE + ".html\">\u8BE6\u7EC6</a>";
            }
        },
        "xg_gk": {
            formatter: function (value, item, i, field) {
                return "<a class=\"red\" href=\"/gjdcg/mx.html?date=" + fieldtools_1["default"].dateformat(item.REPORT_DATE) + "\">\u8BE6\u7EC6</a>";
            }
        },
        "xg_mx": {
            formatter: function (value, item, i, field) {
                return "<a  class=\"red\" style=\"cursor: pointer;\" >\u8BE6\u7EC6</a>";
            },
            events: {
                'click a': function (e, value, row, index) {
                    $("#filter_mkt li").removeClass("at");
                    $("#filter_mkt li[data-value='mx']").addClass("at");
                    $("#box_mx").show();
                    $("#box_tj").hide();
                    $("#filter_date").val(fieldtools_1["default"].dateformat(row.REPORT_DATE)).trigger('change');
                }
            }
        },
        "top3": {
            formatter: function (value, item, i, field) {
                var names = item.SECURITY_NAME_ABBR.split(',');
                var codes = item.SECURITY_CODE.split(',');
                var html = "";
                for (var i_1 = 0; i_1 < names.length; i_1++) {
                    html += "&nbsp;<a href=\"/stockdata/" + codes[i_1] + ".html\">" + fieldtools_1["default"].fmtsname(names[i_1]) + "</a>&nbsp;";
                }
                return html;
            }
        },
        "HOLDER_NAME": {
            formatter: function (value, item, i, field) {
                return "<a href=\"/gdfx/shareholder/" + item.HOLDER_CODE + ".html\">" + value + "</a>";
            }
        },
        "TYPE_CHG": {
            formatter: function (value, item, i, field) {
                var color = '';
                if (value === '减少') {
                    color = 'green';
                }
                if (value === '增加' || value === '新进') {
                    color = 'red';
                }
                return "<span class=\"" + color + "\">" + value + "</span>";
            }
        },
        "REPORT_DATE": emfield.date,
        "NOTICE_DATE": emfield.date,
        "TOTAL_SHARES": emfield.num_trim_end,
        "HOLD_MARKET_CAP": emfield.num_trim_end,
        "SHARES_RATIO": { formatter: { num: 5521, omit: false, zoom: 2 } },
        "STOCK_NUM": emfield.string,
        "INDEX_NAME": emfield.num_trim_end,
        "CHANGE_RATE": { formatter: { num: 2, omit: false, showcolor: true, trim: false, fix: "%" } },
        "ORG_NUM": emfield.string,
        "SECURITY_CODE": emfield.code,
        "SECURITY_NAME_ABBR": emfield.name,
        "TOTAL_SHARES_SUM": emfield.num_trim_end,
        "TOTAL_SHARES_CHANGE": emfield.num_trim_end_c,
        "MARKET_CAP_SUM": emfield.num_trim_end,
        "MARKET_CAP_CHANGE": emfield.num_trim_end_c,
        "SHARES_RATIO_SUM": emfield.bfb,
        "SHARES_RATIO_CHANGE": emfield.bfb_c,
        "AVG_SHARES_RATIO": emfield.bfb,
        "HOLD_COUNT": emfield.string,
        "INDUSTRY_NAME": emfield.string,
        "INDUSTRY_COUNT": emfield.string,
        "INDUSTRY_MARKET_CAP": emfield.num_trim_end,
        "TOTAL_SHARES_CHG": emfield.num_trim_end_c,
        "MARKET_CAP_CHG": emfield.num_trim_end_c,
        "PRE_TOTAL_SHARES": emfield.num_trim_end,
        "TOTAL_SHARES_RATIO": emfield.bfb,
        "PRE_SHARES_RATIO": emfield.bfb,
        "SHARES_RATIO_CHG": {
            formatter: function (value, item, i, field) {
                return fieldtools_1["default"].fieldfmt(value, { num: 5521, omit: false, showcolor: true });
            }
        }
    },
    settip: function (datedef) {
        //M月dd日的逻辑： 如果是一季报 4月30日；如果是半年报 ，8月31日； 如果是三季报 10月30日；如果是年报，4月30日。
        var mm = fieldtools_1["default"].dateformat(datedef.REPORT_DATE, 'MM');
        var jzrq, bgq;
        if (mm == '03') {
            bgq = '一季度';
            jzrq = '4月30日';
        }
        else if (mm == '06') {
            bgq = '半年度';
            jzrq = '8月31日';
        }
        else if (mm == '09') {
            bgq = '三季度';
            jzrq = '10月30日';
        }
        else if (mm == '12') {
            bgq = '年度';
            jzrq = '4月30日';
        }
        if (datedef.IS_COMPLETE == 1) {
            $('.tipsdiv div').html("\u8BF4\u660E\uFF1A\u91CD\u8981\u673A\u6784\uFF08\u4E2D\u592E\u6C47\u91D1\u3001\u4E2D\u56FD\u8BC1\u5238\u91D1\u878D\u3001\u4E2D\u8BC1\u8D44\u7BA1\u7B49\uFF09\u6301\u80A1\u6570\u636E\u6765\u6E90\u4E8E\u4E0A\u5E02\u516C\u53F8\u3001\u57FA\u91D1\u516C\u53F8\u62A5\u544A\u671F\u62AB\u9732\u6570\u636E\u7EDF\u8BA1\u3002\u6839\u636E\u76D1\u7BA1\u8981\u6C42\uFF0C\u622A\u6B62\u81F3" + jzrq + "\uFF0C" + fieldtools_1["default"].dateformat(datedef.REPORT_DATE, 'YYYY年') + bgq + "\u62A5\u544A\u5DF2\u62AB\u9732\u5B8C\u6BD5\uFF08\u56E0\u7279\u6B8A\u60C5\u51B5\u5EF6\u671F\u62AB\u9732\u7684\u9664\u5916\uFF09");
        }
        else {
            $('.tipsdiv div').html("\u8BF4\u660E\uFF1A\u91CD\u8981\u673A\u6784\uFF08\u4E2D\u592E\u6C47\u91D1\u3001\u4E2D\u56FD\u8BC1\u5238\u91D1\u878D\u3001\u4E2D\u8BC1\u8D44\u7BA1\u7B49\uFF09\u6301\u80A1\u6570\u636E\u6765\u6E90\u4E8E\u4E0A\u5E02\u516C\u53F8\u3001\u57FA\u91D1\u516C\u53F8\u62A5\u544A\u671F\u62AB\u9732\u6570\u636E\u7EDF\u8BA1\u3002\u76EE\u524D" + fieldtools_1["default"].dateformat(datedef.REPORT_DATE, 'YYYY年') + bgq + "\u62A5\u544A\u6301\u7EED\u62AB\u9732\u4E2D\uFF0C\u81F3\u62AB\u9732\u622A\u6B62\u65E5\uFF08" + jzrq + "\uFF09\u671F\u95F4\u8BE5\u6570\u636E\u4F1A\u6301\u7EED\u66F4\u65B0\u3002");
        }
    }
};
window["pageopt"] = pageopt;
exports["default"] = pageopt;
